import { useQuery } from "@tanstack/react-query"

import {
  fetchPublicIntakeFormInvitation,
  fetchPublicIntakeFormInvitationDraft,
  fetchPublicIntakeFormInvitationHtml,
  fetchPublicIntakeFormPublication,
  fetchPublicIntakeFormPublicationHtml,
  fetchPublicOutboundFormDemoHtml,
} from "./api"

export function useFetchPublicOutboundFormDemoHtml(token: string) {
  return useQuery({
    queryKey: ["outbound_form_demo_html", token],
    queryFn: () => fetchPublicOutboundFormDemoHtml(token),
    enabled: Boolean(token),
    retry: false,
  })
}

export function useFetchPublicIntakeFormPublication(token: string) {
  return useQuery({
    queryKey: ["intake_form_web_publication", token],
    queryFn: () => fetchPublicIntakeFormPublication(token),
    enabled: Boolean(token),
    retry: false,
  })
}

export function useFetchPublicIntakeFormInvitation(token: string, sessionToken: string | null) {
  return useQuery({
    queryKey: ["intake_form_invitation", token, sessionToken],
    queryFn: () => fetchPublicIntakeFormInvitation(token, sessionToken),
    enabled: Boolean(token),
    retry: false,
  })
}

export function useFetchPublicIntakeFormInvitationDraft(token: string, sessionToken: string | null) {
  return useQuery({
    queryKey: ["intake_form_invitation_draft", token, sessionToken],
    queryFn: ({ signal }) => fetchPublicIntakeFormInvitationDraft(token, sessionToken as string, signal),
    enabled: Boolean(token) && Boolean(sessionToken),
    staleTime: 0,
    refetchOnMount: "always",
    retry: false,
  })
}

// The document is immutable for a given version, so it never needs refetching
// once loaded — the shell decides when to pin a different version.
export function useFetchPublicIntakeFormPublicationHtml(token: string, versionId: string | null) {
  return useQuery({
    queryKey: ["intake_form_version_html", token, versionId],
    queryFn: () => fetchPublicIntakeFormPublicationHtml(token, versionId as string),
    enabled: Boolean(token) && Boolean(versionId),
    staleTime: Infinity,
    retry: false,
  })
}

export function useFetchPublicIntakeFormInvitationHtml(
  token: string,
  versionId: string | null,
  sessionToken: string | null
) {
  return useQuery({
    queryKey: ["intake_form_version_html", token, versionId],
    queryFn: () => fetchPublicIntakeFormInvitationHtml(token, sessionToken as string),
    enabled: Boolean(token) && Boolean(versionId) && Boolean(sessionToken),
    staleTime: Infinity,
    retry: false,
  })
}
